import types from './types';

export const setShelterName = shelterName => ({
  type: types.SET_SHELTERT_NAME,
  shelterName
});

export const setYearList = yearList => ({
  type: types.SET_YEAR_LIST,
  yearList
});

export const setKojinInfo = kojinInfo => ({
  type: types.SET_KOJIN_INFO,
  kojinInfo
});

export const setSetaiInfo = setaiInfo => ({
  type: types.SET_SETAI_INFO,
  setaiInfo
});

export const setKojinInfoDetail = kojinInfoDetail => ({
  type: types.SET_KOJIN_INFO_DETAIL,
  kojinInfoDetail
});

 export default {
   setYearList,
   setShelterName,
   setKojinInfo,
   setSetaiInfo,
   setKojinInfoDetail
 };
